import React from 'react';
import { Popover as MBWPopover } from '@barges/react';
import FiltersContainer from '../inner_views/filters';
import classes from './classes.module.scss';
import { SvgIcon } from '../../../../common/sprites';
import { PopoverPayload } from '../inner_views/filters/useFilterPopover';

interface SearchResultFilterPopoverProps {
  isOpen: boolean;
  payload: PopoverPayload | null;
  dismissPopover: () => void;
}

const SearchResultFilterPopover: React.FC<SearchResultFilterPopoverProps> = ({
  isOpen,
  payload,
  dismissPopover
}) => {
  const renderCloseBtn = () => (
    <div className={ classes.closeButtonContainer }>
      <button className={ classes.closeButton } type="button" onClick={ dismissPopover }>
        <SvgIcon id="close_icon" size={ 22 } />
      </button>
    </div>
  );

  return (
    <MBWPopover
      isOpen={ isOpen }
      renderCloseButton={ renderCloseBtn }
      onCloseButtonClick={ dismissPopover }
      closeOnBackdropClick
    >
      <div className={ classes.popoverContainer }>
        <FiltersContainer
          popoverView
          autofocus={ payload?.autoFocus }
          dissmissPopover={ dismissPopover }
          history={ payload?.history }
          location={ payload?.location }
        />
      </div>
    </MBWPopover>
  );
};

export default SearchResultFilterPopover;
